import { render, staticRenderFns } from "./MypageTicketTodayConfirmModalSection.vue?vue&type=template&id=0b30732c&scoped=true"
import script from "./MypageTicketTodayConfirmModalSection.vue?vue&type=script&lang=ts"
export * from "./MypageTicketTodayConfirmModalSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketTodayConfirmModalSection.vue?vue&type=style&index=0&id=0b30732c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b30732c",
  null
  
)

export default component.exports